// Placeholder for an idea of a Wrapper with render props to recycle handleChange and other stuffs.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { AppProvider, Page, Toast, Frame } from '@shopify/polaris';
// import SimpleToast from '@presentational/information/SimpleToast'
import translations from '@shopify/polaris/locales/es.json';
import { pick } from 'lodash';
import axiosRails from '@utils/axios';

import { BlankSchema } from 'utils/validationSchemas';

const propTypes = {
  defaultValues: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.number, PropTypes.arrayOf(PropTypes.node), ]).isRequired,

  wrapper: PropTypes.bool,
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.object, ]),

  handleSubmit: PropTypes.func, // Default submit requires  submitURL and submitMethod
  pickValuesCallback: PropTypes.func, // custom build values to send with default flow

  submitURL: PropTypes.string,
  submitMethod: PropTypes.string,
  paramsName: PropTypes.string,

  pagePros: PropTypes.object, // Page Wrapper props
  extraValues: PropTypes.object, // Extra values to send to the backend

  containerClass: PropTypes.string,
  validationSchema: PropTypes.object, // from YUP
};

const defaultProps = {
  wrapper: false,
  title: "",
  pageProps: {},
  submitMethod: "POST",
  containerClass: "polaris-form-provider"
}

class PolarisFormProvider extends Component {
  // state ={
    // showToast: false
  // }

  render() {
    const formikStatus = this.props.status;
    const isValid = this.props.isValid && this.props.dirty; // This property(isValid) does not take the value of dirty into account anymore [since formik 2]. For easier usage isValid if "isValid" AND Form has been changed

    let renderProps = {
      ...pick(this.props, ['setFieldValue', 'values', 'handleSubmit', 'errors', 'status', 'touched', 'handleBlur']),
      handleChange: this.handlePolarisChange,
      handleChangeNumber: this.handlePolarisChangeNumber,
      handleChangeSeller: this.handleChangeSeller,
      toggleValue: this.toggleValue,
      pushNewValue: this.pushNewValue,
      pushToast: this.pushToast,
      loading: formikStatus.submitLoading,
      isValid: isValid,
    }
    // console.log("PolarisFP", this.props);
    return (
      <AppProvider i18n={translations}>
        <Frame>
          <div className={ this.props.containerClass }>
            <Page
              title={ this.props.title }
              {...this.props.pageProps}
            >
              { this.props.children(renderProps) }
            { formikStatus.showToast ?
              <Toast
                content={formikStatus.toastContent}
                onDismiss={this.closeToast} />
              : null
            }
            </Page>
          </div>
        </Frame>
      </AppProvider>
    );
  }

  handlePolarisChange = (value, id) => {
    const { setFieldValue, setFieldTouched } = this.props;
    setFieldValue(id, value);
  }

  // OPTIMIZE This is used only on one form.... 
  handleChangeSeller = (value, id) => {
    const { setFieldValue } = this.props;
    setFieldValue("seller." + id, value)
  }

  handlePolarisChangeNumber = (value, id) => {
    const { setFieldValue } = this.props;
    setFieldValue(id, Number(value));
  }

  toggleValue = (field) => {
    const { values, setFieldValue } = this.props;
    setFieldValue(field, !values[field]);
  }

  pushNewValue = (name, newRecord) => {
    let { setFieldValue, values } = this.props;
    let currentArray = values[name];
    let newArray = [
      newRecord,
      ...currentArray,
    ]
    console.log("Push new value", newRecord);
    setFieldValue(name, newArray);
  }

  closeToast = () => {
    const { status, setStatus } = this.props;
    setStatus({
      ...status,
      showToast: false,
    })
  };

  pushToast = (message) => {
    const { status, setStatus } = this.props;
    setStatus({
      ...status,
      showToast: true,
      toastContent: message
    })
  }
  // onImageUpload = (fieldName, files) => {
  //   let { values } = this.props;
  //   setFieldValue(field, )
  // }
}


PolarisFormProvider.propTypes = propTypes;
PolarisFormProvider.defaultProps = defaultProps;

const FormWithFormik = withFormik({
  mapPropsToValues: (props) => {
    return props.defaultValues;
  },

  mapPropsToStatus: (props) => ({
    submitLoading: false,
    showToast: false,
    toastContent: "",
  }),

  enableReinitialize: true,
  validationSchema: (props) => props.validationSchema || BlankSchema, // If null is provided formik 2.x display an error

  handleSubmit: async (values, formikBag) => {
    const { setStatus } = formikBag;

    if(formikBag.props.handleSubmit){
      await formikBag.props.handleSubmit(values, formikBag); // <======================= customHandleSubmit
    }
    else{
      // Default Submit behavior
      setStatus({ submitLoading: true  });
      let submitValues;
      if(!!formikBag.props.pickValuesCallback){
        try {
          submitValues = formikBag.props.pickValuesCallback(values, formikBag);
        } catch (error) { // general catch for not handled errors on pickValuesCallback
          alert("Ocurrio un error, intente de nuevo o contacte al administrador");
          setStatus({ submitLoading: false  });
          return false; // EARLY RETURN
        }
      }
      else{ // legacy
        if(formikBag.props.paramsName){ // DEPRECATED! paramsName should be somewhat required
          submitValues = {
            [formikBag.props.paramsName]: values
          }
        }
        else{
          submitValues = values;
        }
  
        // Extra values to send along. (DEPRECATED. Instances should be replaced with pickValuesCallback)
        if(formikBag.props.extraValues){
          submitValues = {
            ...submitValues,
            extraValues: formikBag.props.extraValues
          }
        }
      }

      // Default handleSubmit
      // console.log("SUBMIT!", submitValues);
      let { submitMethod, submitURL } = formikBag.props;

      // Might need a try/catch here
      try {
        let response = await axiosRails({
          method: submitMethod,
          data: submitValues,
          url: submitURL,
        });
  
        let { data, status } = response;
  
        if (data.success) {
          formikBag.setStatus({
            submitLoading: false,
            showToast: true,
            toastContent: I18n.t("app.messages.save_success")
          });
          window.location = data.redirectURL;
          return true;
        }
        else {
          console.warn(data);
          console.log("Errors", data.errors);
  
          formikBag.setStatus({
            submitLoading: false,
            showToast: true,
            toastContent: I18n.t("app.messages.record_errors")
          })
          formikBag.setErrors(data.errors);
        }
      } catch (error) {
        alert("Ocurrio un error con la conexión");
        setStatus({ submitLoading: false  });
      }

    }
  }
})(PolarisFormProvider)


export default FormWithFormik;
